const lineChartStrings = {
  daySuffixes: {
    suffixes: {
      th: 'th',
      st: 'st',
      nd: 'nd',
      rd: 'rd',
    },
  },
};

export default lineChartStrings;
